(function () {
  let debounceTimer;

  document.addEventListener('change', function (e) {
    if (!e.target.closest('#facets-drawer')) return;

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(updateDrawerCount, 300);
  });

  function updateDrawerCount() {
    const drawer = document.getElementById('facets-drawer');
    if (!drawer) return;

    const form = drawer.querySelector('form');
    if (!form) return;

    const url = new URL(window.location.origin + window.location.pathname);

    const formData = new FormData(form);

    for (const [key, value] of formData.entries()) {
      if (value !== '') {
        url.searchParams.append(key, value);
      }
    }

    const sectionElement = document.querySelector('.shopify-section--main-collection');
    if (!sectionElement) return;

    const sectionId = sectionElement.id.replace('shopify-section-', '');
    url.searchParams.set('section_id', sectionId);

    fetch(url.toString())
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then(function (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newCountElement = doc.querySelector('[data-products-count]');
        if (!newCountElement) return;

        const countText = newCountElement.textContent.trim();

        const drawerCount = document.getElementById('drawer-product-count');
        if (drawerCount) {
          drawerCount.textContent = countText;
        }
      })
      .catch(function (error) {
        console.error('Drawer count update failed:', error);
      });
  }
})();